<template>
    <div class="row">
        <div class="col-12 my-2">

            <div class="card-header-actions">

              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-8 card-header-search-box">
                    <div class="input-group">
                      <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search" @keypress.enter="initList">
                      <div class="input-group-append">
                          <button class="all-btn search-btn" @click="initList">
                              <i class="fa fa-search"></i>
                          </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" @click="showConstructiveFieldEditModal(null)" v-if="hasPermission('SETTINGS_CAD_BUILDING_CONSTRUCTIVE_ADD')">{{$t("action.add")}}</button>
              </div>

            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                      <tr>
                          <th>#</th>
                          <th>Категория</th>
                          <th>Фойдаланиш мақсади</th>
                          <th>Кадастр иншоат тури</th>
                          <th>Бино тури</th>
                          <th>Зилзила бардошлилик</th>
                          <th>Конструктив элементлар</th>
                          <th class="text-center">{{$t("realEstate.field.action")}}</th>
                      </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                  <tr v-for="(result,index) in results.data" :key="result.id">
                      <td>{{result.id}}</td>
                      <td>
                          <span v-if="result.section.category==='Notorious'">Нотурар</span>
                          <span v-if="result.section.category==='Residential'">Турар</span>
                      </td>
                      <td>{{result.buildingType.name}}</td>
                      <td>{{result.section.name}}</td>
                      <td>{{result.cadastreBuilding.name}}</td>
                      <td>{{result.earthquakePoint}}</td>
                      <td>
                          <button class="all-btn" v-b-toggle="'constructionElement'+ index">
                              <i class="fa fa-eye"></i>
                          </button>
                          <b-collapse :id="'constructionElement' + index">
                              <template v-for="(element,index) in getConstructiveElementNameAndValue(result)">
                                  <div :key="index" class="mb-2" style="min-width: 200px;">
                                      <span>{{element.name}}: </span>
                                      <span class="form-control">{{element.value}}</span>
                                  </div>
                              </template>
                          </b-collapse>
                      </td>
                      <td class="td-actions text-center">
                          <button class="all-btn edit-btn table-action" data-original-title="Edit"
                                  @click="showConstructiveFieldEditModal(result)">
                              <i class="fa fa-edit"></i>
                          </button>
                      </td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <CadastreBuildingConstructiveFieldEditModal />
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import CadastreBuildingConstructiveFieldEditModal from '@/views/config/cadastre/CadastreBuildingConstructiveFieldEditModal.vue'
    import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
    import { VBToggle } from 'bootstrap-vue/es/directives/toggle/toggle'

    export default {
        name: "CadastreBuildingConstructiveFieldList",
        components: {
            'b-pagination': bPagination,
            BCollapse,
            CadastreBuildingConstructiveFieldEditModal
        },
        directives: {
            'b-toggle': VBToggle
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
                cadastreBuildingFields: [],
                cadastreBuildingFieldReferences: []
            }
        },
        methods: {
            initList() {
                this.loading = true;
                const vm = this;

                const promises = [
                    this.$http.get('/cadastre/building/init')
                ];
                promises.push(this.$http.post('cadastre/building/constructive-field/list', this.filter));

                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;

                    vm.cadastreBuildingFields = initData.fields;
                    vm.cadastreBuildingFieldReferences = initData.references;

                    if (values.length >= 2) {
                        vm.results = values[1].data;
                        vm.loading = false;
                    }

                });
            },
            showConstructiveFieldEditModal(data) {
                this.$eventBus.$emit('showConstructiveFieldEditModal',data)
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            getConstructiveElementNameAndValue(data) {

                let constructiveElements = [];
                this.cadastreBuildingFields.forEach((field) => {
                    if (field.code && !field.system && data.constructiveElements.hasOwnProperty(field.code)) {
                        const fieldValue = data.constructiveElements[field.code];
                        if (fieldValue) {
                            if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                                if (fieldValue.id && fieldValue.id > 0) {
                                    let name = field.name;
                                    const ref = this.getReferenceById(field.reference.code, fieldValue.id);
                                    const element = {
                                        name: name,
                                        value: ref.name
                                    };
                                    constructiveElements.push(element);
                                }
                            }
                        }
                    }
                });
                return constructiveElements;
            },
            getReferenceById(code, id) {
                if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
                    const fieldReferences = this.cadastreBuildingFieldReferences[code];
                    const references = fieldReferences.filter((ref) => {
                        return ref.id === id
                    });
                    return references.length > 0 ? references[0] : null;
                } else {
                    return null;
                }
            },
        },
        created() {
            this.initList();
            this.$eventBus.$on('cadastreBuildingConstructiveFieldChanged', () => {
                this.initList();
            })
        }
    }
</script>

<style scoped>

</style>